/** G1 journey helpers — pre-G1 vs post-G1 surfaces. Does not rename G1–G8. */

import { navItemAllowed } from "./master";

export const POST_G1_ONLY_ROUTES = [
  "/cockpit",
  "/decision",
  "/enterprise",
  "/governance",
  "/delivery",
  "/lifecycle",
];

export function isPreG1(app) {
  return app?.g1_journey?.phase === "pre_g1";
}

export function g1Readiness(app) {
  return app?.g1_journey || null;
}

export function navItemAllowedForApp(href, guide, app) {
  if (!navItemAllowed(href, guide)) return false;
  const path = String(href || "/").split("?")[0];
  if (app && isPreG1(app) && POST_G1_ONLY_ROUTES.includes(path)) return false;
  return true;
}

export function appOpenRouteForApp(guide, app) {
  const pre = app && isPreG1(app);
  const order = pre
    ? ["/overview", "/evidence", "/assessment", "/applications", "/program", "/"]
    : ["/cockpit", "/decision", "/lifecycle", "/governance", "/assessment", "/delivery", "/"];
  return order.find((href) => navItemAllowedForApp(href, guide, app)) || "/";
}
